module.exports = __webpack_public_path__ + "static/media/plan-guardians-phone1.60c60aa3.png";